import { Component, OnInit } from '@angular/core';
import { CurrentUserService } from '@core/services/currentUser.service';
import { AuthService } from '@auth0/auth0-angular';
import { filter, take } from 'rxjs/operators';

// Bump this ID whenever you want a new banner to show (even to users who dismissed the previous one)
const BANNER_ID = 'v1';

@Component({
  selector: 'app-announcement-banner',
  templateUrl: './announcement-banner.component.html',
  styleUrls: ['./announcement-banner.component.scss'],
})
export class AnnouncementBannerComponent implements OnInit {
  visible = false;
  private userSub = '';

  constructor(
    private currentUserService: CurrentUserService,
    private authService: AuthService,
  ) {}

  get tenantId(): string {
    return this.currentUserService.tenantGlobalService ?? '';
  }

  ngOnInit(): void {
    this.authService.user$.pipe(
      filter(user => !!user?.sub),
      take(1),
    ).subscribe(user => {
      this.userSub = user!.sub!;
      const key = `banner_dismissed_${this.userSub}_${BANNER_ID}`;
      this.visible = !localStorage.getItem(key);
    });
  }

  dismiss(): void {
    this.visible = false;
    if (this.userSub) {
      localStorage.setItem(`banner_dismissed_${this.userSub}_${BANNER_ID}`, '1');
    }
  }
}
